/* This file is autogenerated, see readme.md for instructions */
import DesktopSvgIcon from '@bloomreach/banana-theme/icons/desktop.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const DesktopIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <DesktopSvgIcon />
    </Icon>
  );
});

DesktopIcon.displayName = 'DesktopIcon';

export default DesktopIcon;
